import { ILocationApiV5Model } from '@app/core/models/api/location.api.model';

export class LocationModel {
  id: number;

  name: string;

  locationInfo: {
    address: string;
    point: {
      latitude: number;
      longitude: number;
    };
    googlePlaceId: string;
  };

  emojiUrl?: string;

  constructor(source: ILocationApiV5Model) {
    this.id = source.id;
    this.name = source.name;
    this.locationInfo = {
      point: source.point,
      address: source.address,
      googlePlaceId: source.google_place_id,
    };
  }
}
